import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getSettings } from "store/actions";

const Layout = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="content-wrap" id="content-wrapper">
        {props.children}
        <Outlet />
      </div>
    </div>
  );
};
export default Layout;
